export const get_crm_responses = "host/v2/crm/responses";
